import { ReactNode, useMemo, Fragment } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const Divider: FCX<{
    items?: ReactNode[];
    lineBg?: string;
}> = ({
    className,
    items,
    lineBg,
    testId,
    ...props
}) => {
    const children = useMemo(
        () => {
            const itemsToRender = items ?? ['', ''];
            return itemsToRender.map((item, index) => {
                const isLastItem = itemsToRender.length === ++index
                return (
                    <Fragment key={`DividerItem${index}`}>
                        {item}
                        {!isLastItem && (
                            <div
                                className="Divider__line"
                                style={{
                                    background: lineBg,
                                }}
                            />
                        )}
                    </Fragment>
                )
            })
        },
        [items, lineBg]
    );

    return (
        <div
            className={cn(
                "Divider",
                className,
            )}
            data-testid={testId ?? "blockDivider"}
            {...props}
        >
            {children}
        </div>
    );
};

export default Divider;